(function(app) {
    app.constant("suffixes",
    [
        "Jr",
        "Sr",
        "II",
        "III",
        "CLTC",
        "RN",
        "ADN",
        "LUTCF",
        "CLU",
        "CFP",
        "RICP",
        "MBA",
        "MD",
        "PhD"
    ]);
})(window.app); //jshint ignore:line